module.exports = __webpack_public_path__ + "static/media/Maps-Version-One.0504775a.mp4";